import { render, staticRenderFns } from "./pwa_payment_tab.vue?vue&type=template&id=6e1225b9&scoped=true&"
import script from "./pwa_payment_tab.vue?vue&type=script&lang=js&"
export * from "./pwa_payment_tab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e1225b9",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/getorder/api/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6e1225b9')) {
      api.createRecord('6e1225b9', component.options)
    } else {
      api.reload('6e1225b9', component.options)
    }
    module.hot.accept("./pwa_payment_tab.vue?vue&type=template&id=6e1225b9&scoped=true&", function () {
      api.rerender('6e1225b9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/app/components/aggregators/pwa/location/tabs/pwa_payment_tab.vue"
export default component.exports